




























import {Component, Prop, PropSync, Vue, Watch} from 'vue-property-decorator';
import CompSelectBox from '@/components/common/CompSelectBox.vue';
import {ClaimType, SelectListItem} from '@/types/claim';

@Component({
  components: {
    CompSelectBox
  }
})
export default class SearchWordSelect extends Vue{
  private searchTypeSelectList: SelectListItem[] = []

  @Prop({required: true})
  private readonly mallNo!: undefined | number;

  @Prop({required: true})
  private readonly searchFormType!: ClaimType

  @PropSync('searchType')
  private searchTypeSync!: string // TODO: enum 확인

  @PropSync('keyword')
  private keywordSync!: string

  private onKeydownEnter(event){
    if (event.isComposing || event.keyCode === 229)  return;
    this.$emit('enterSearch')
  }

  //TODO: 리팩토링
  @Watch('mallNo')
  async fetchAndSetSearchTypes(){
    const mallNo = this.mallNo ? this.mallNo : ''

    if(this.searchFormType === ClaimType.REFUND){
      const {data: searchTypes} = await (this.$api as any).getRefundsSearchConditions({params: {mallNo: Number(mallNo)}}) // 계속 없는 meargeApi라고 하는데 모르겠음

      this.searchTypeSelectList = searchTypes.types.map(searchType => ({
        name: searchType.label,
        value: searchType.type
      }))

      return
    }

    const {data: searchTypes} = await this.$api.getClaimsSearchConditions({params: {mallNo: Number(mallNo), claimType: this.searchFormType}})
    this.searchTypeSelectList = searchTypes.types.map(searchType => ({
      name: searchType.label,
      value: searchType.type
    }))
  }

  private created(){
    this.fetchAndSetSearchTypes()
  }
}
